// src/layouts/SidebarLayout.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SideNavbar from "../components/common/SideNavbar";
import Navbar from "./navbar/Navbar";
import ImpersonationBanner from "../components/common/ImpersonationBanner";
import { buildApiUrl, API_ENDPOINTS } from "../config/api";
import { apiRequest } from "../utils/apiUtils";
import { extractOrganizationId } from "../utils/organization";
import "../styles/SideNavbar.css";

function SidebarLayout({ children }) {
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeMeasurementName, setActiveMeasurementName] = useState("");
  const [activeMeasurementCorrelativo, setActiveMeasurementCorrelativo] =
    useState("");

  useEffect(() => {
    let cancelled = false;

    const loadActiveMeasurement = async () => {
      try {
        let orgId = "";
        const selectedOrgRaw = localStorage.getItem("selectedOrg");

        if (selectedOrgRaw) {
          const selectedOrg = JSON.parse(selectedOrgRaw);
          orgId = String(extractOrganizationId(selectedOrg) || "").trim();
        }

        if (!orgId) {
          const sessionData = await apiRequest(
            buildApiUrl(API_ENDPOINTS.current),
          );
          orgId = String(
            extractOrganizationId(sessionData?.datosUsuario?.organization) || "",
          ).trim();
        }

        if (!orgId) {
          if (!cancelled) {
            setActiveMeasurementName("");
            setActiveMeasurementCorrelativo("");
          }
          return;
        }

        const response = await apiRequest(
          buildApiUrl(`${API_ENDPOINTS.surveys}/measurements?org=${orgId}`),
        );
        const measurements = Array.isArray(response?.measurements)
          ? response.measurements
          : [];
        const activeMeasurement = measurements.find((item) =>
          Boolean(item?.isActive),
        );

        if (cancelled || !activeMeasurement) {
          if (!cancelled) {
            setActiveMeasurementName("");
            setActiveMeasurementCorrelativo("");
          }
          return;
        }

        setActiveMeasurementName(
          String(activeMeasurement?.measurementName || "").trim(),
        );
        setActiveMeasurementCorrelativo(
          String(activeMeasurement?.correlativo || "").trim(),
        );
      } catch (error) {
        if (!cancelled) {
          setActiveMeasurementName("");
          setActiveMeasurementCorrelativo("");
        }
      }
    };

    loadActiveMeasurement();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  const resolvedActiveMeasurementName =
    activeMeasurementName ||
    (activeMeasurementCorrelativo
      ? `Medición ${activeMeasurementCorrelativo}`
      : "");

  return (
    <div className="layout-container">
      <SideNavbar
        isCollapsed={isSidebarCollapsed}
        onToggle={setIsSidebarCollapsed}
      />
      <div
        className={`main-content ${
          isSidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
      >
        <Navbar />
        <ImpersonationBanner />
        <div className="active-measurement-banner" role="status">
          {resolvedActiveMeasurementName
            ? `Medición activa: ${resolvedActiveMeasurementName}`
            : "Medición activa: sin medición activa"}
        </div>
        <main className="content-area">{children}</main>
      </div>
    </div>
  );
}

export default SidebarLayout;
